/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import * as playlistStore from '../util/playlistStore'
import * as links from '../util/links'
import {valueFor} from '../util/helpers'

const jumpToPlaylist = 'touch-chains'

class QALinksResolver extends Component {

    componentDidMount() {
        //this.props.load(this.props.teamId, this.props.gameId, this.props.eventNumber, this.props.history)
    }

    componentDidUpdate() {
        if(this.props.game && this.props.game.events && this.props.game.events.length > 2 && this.props.game.playlists.length > 1) {
            let currentPlaylist = playlistStore.getPlaylist(this.props.playlistId, {game: this.props.game})
            if(currentPlaylist.event_count <= 1) {
                let playlist = playlistStore.getPlaylist(jumpToPlaylist, {game: this.props.game})
                let events = playlistStore.filterEventsWithPlaylist(playlist, this.props.game.events)
                const link = links.gameUrl(this.props.teamId, jumpToPlaylist, this.props.gameId, events[0].event_number)
                this.props.history.replace(link)
            } else {
                let events = playlistStore.filterEventsWithPlaylist(currentPlaylist, this.props.game.events)
                events = this.filterByMeta(events, this.props.metaType, this.props.metaValue)
                console.log(events)
                if(events.length > 0) {
                    let item = events[Math.min(events.length-1, this.props.eventNumber - 1)]
                    console.log(item)
                    let link = links.gameUrl(this.props.teamId, this.props.playlistId, this.props.gameId, item.event_number)
                    if(this.props.suffix) {
                        link = `${link}/${this.props.suffix}`
                    }
                    this.props.history.replace(link)
                }
            }
        }
    }

    render() {
        return null
    }

    filterByMeta(events, metaType, metaValue) {
        if(!events) return []

        let finalEvents=[]
        let addOnEvents=[]
        for(let j=0, jlen = events.length; j<jlen; ++j)
        {
            let e = events[j]
            let metaItem = valueFor(metaType, undefined, e.meta)
            if(metaItem) {
                if(Array.isArray(metaItem)) {
                    let hasVal = false
                    let missVal = false
                    for(let i=0, len=metaItem.length;i<len;++i) {
                        let eq = metaItem[i].toString() === metaValue
                        hasVal |= eq
                        missVal |= !eq
                    }
                    if(hasVal && !missVal) finalEvents.push(e)
                    if(hasVal && missVal) addOnEvents.push(e)
                } else {
                    if(metaItem.toString() === metaValue) finalEvents.push(e)
                }
            }
        }

        finalEvents.push(...addOnEvents)
        return finalEvents
    }
}

const mapStateToProps = (state, props) => {
    let game = state.game.value
    let teamId = props.match.params.team_id
    let origGameId = props.match.params.game_id
    let eventNumber = parseInt(props.match.params.seq_num, 10)
    let metaType = props.match.params.meta_type
    let metaValue = '' + props.match.params.meta_value
    let suffix = props.match.params.suffix
    let playlistId = props.match.params.playlist

    let gameIdParts = origGameId.split('-')
    let gameId = origGameId
    if (gameIdParts.length > 1) {
        gameId = gameIdParts[1]
    }
    console.log('game_id', gameId)
    if (gameId !== origGameId) {
        window.location.hash = window.location.hash.replace(origGameId, gameId)
        window.location.reload()
    }


    return {
        teamId,
        gameId,
        eventNumber,
        metaType,
        metaValue,
        suffix,
        playlistId,
        game
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        load: (teamId, gameId, eventNum, history) => {
            //dispatch(playlistActions.loadPlaylists(teamId))
            //dispatch(act.loadGame(teamId, gameId, eventNum, history))
        }
    }
}

const QALinksResolverComponent = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(QALinksResolver))

export default QALinksResolverComponent

